/**
 * GDix OpenAPI
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// @Version 1.0.2
/* tslint:disable:no-unused-variable member-ordering */
type ValidProps = '_links' | 'result'
interface IStringIndex extends Record<ValidProps, any> {}
interface IAuthorizationHeader {
   Authorization?: string
}

export enum DPSAPI {
   ERROR = 'ERROR',
   INVOKEBACKEND = 'GET_VERSION',
   INVOKEBACKENDPARAM = 'BACKEND',
   AUTHEXTERNUSER = 'UserExtern',
   HEADER_AUTH = 'Authorization',
   HEADER_AUTH_PREFIX = 'Bearer ',
   SESSIONINFO_KEY_ACCESS = 'accesstoken',
   ERROR_EXCEPTION_401 = 'HTTP Status Code: 401',
   ERROR_EXCEPTION_401_URL = 'Authorization/Change/Password',
   ERROR_EXCEPTION_500 = 'HTTP Status Code: 500',
   ERROR_EXCEPTION_500_URL = 'Authorization/Logout'
}

import { Inject, Injectable, Optional, Injector }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { PayloadSendData } from '../model/models';
import { ResponseCheckCodeWithBirthday } from '../model/models';
import { ResponseCheckCodeWithoutBirthday } from '../model/models';
import { ResponseLoadBankamountData } from '../model/models';
import { ResponseLoadConsentData } from '../model/models';
import { ResponseLoadQuestionContent } from '../model/models';
import { ResponseLoadQuestionList } from '../model/models';
import { ResponseLoadUserData } from '../model/models';
import { ResponseProjectVersion } from '../model/models';
import { ResponseSendData } from '../model/models';

import { BASE_PATH }                     from '../variables';
import { Configuration }                                     from '../configuration';

import { ErrorOpenApiService } from 'src/app/shared/services/errorHandler/error-openapi.service' 
import { EMPTY, Observable, from, of, reduce  } from 'rxjs';
import { expand, scan, catchError, map, switchMap, tap, takeWhile, first } from 'rxjs/operators';

declare var dps_api: any; 
declare var uuid: any;

'11.07.2025 13:13:46'



@Injectable({
  providedIn: 'root'
})
export class DefaultService {

   protected basePath = 'http://localhost:8080/API/OAS';
   public defaultHeaders = new HttpHeaders();
   public configuration = new Configuration();
   public encoder: HttpParameterCodec;

   constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration, private injector: Injector) {
      if (configuration) {
         this.configuration = configuration;
      }
      if (typeof this.configuration.basePath !== 'string') {
         if (typeof basePath !== 'string') {
            basePath = this.basePath;
         }
         this.configuration.basePath = basePath;
      }
      this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
   }

   public async Connected () {
      if(this.isUuid()) await dps_api.connect_async(); 
   }

   public isConnected(): boolean {
      return dps_api.is_connected()
   }

   public isDpsApi(): boolean {
      return typeof dps_api == 'undefined' ?  false : true
   }
   
   public getBackendVersion(): Observable<string> {
      return  from<Observable<string>>(dps_api.invoke(DPSAPI.INVOKEBACKEND, DPSAPI.INVOKEBACKENDPARAM)).pipe(
         catchError(error => {
            console.log('catchError', error)
            return of('');
         }),
         map((response: string) => response)
      )
   }

   public isUuid(): boolean {
      return typeof uuid == 'undefined' ?  false : true
   }

   /**
   * @param code 
   * @param birthday 
   * @param consultantuuid 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */

   public dPSOKV1CheckWithCodeBirthdayConsultantuuidGet (identifier: object, payload: object, page?: boolean, pagenr?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ResponseCheckCodeWithBirthday | string>
   {

      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSOKV1CheckWithCodeBirthdayConsultantuuidGet.');
      }
      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSOKV1CheckWithCodeBirthdayConsultantuuidGet.');
      }
      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSOKV1CheckWithCodeBirthdayConsultantuuidGet.');
      }

 
      let authMethods: string[] = []; 
      authMethods.push("ClientName");
      authMethods.push("Secret");

      const headers = authMethods.filter(elem => elem == DPSAPI.AUTHEXTERNUSER).length > 0 ? {[DPSAPI.HEADER_AUTH]: DPSAPI.HEADER_AUTH_PREFIX + sessionStorage.getItem(DPSAPI.SESSIONINFO_KEY_ACCESS)} : {};
      let save = Object.values(identifier);

      let commandUrl = '/DPS/OK/v1/check/with/${this.configuration.encodeParam({name: &quot;code&quot;, value: code, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}/${this.configuration.encodeParam({name: &quot;birthday&quot;, value: birthday, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}/${this.configuration.encodeParam({name: &quot;consultantuuid&quot;, value: consultantuuid, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}'; 
      if (commandUrl[0] == '/') {
         commandUrl = commandUrl.substring(1); 
      }
      commandUrl = commandUrl.split('/').map(item => item.includes('${this.configuration.encodeParam') ? save.shift() : item).join('/') 
      commandUrl += `?page=${pagenr ?? '0'}&limit=1000`

      return this._dPSOKV1CheckWithCodeBirthdayConsultantuuidGet(commandUrl, headers, payload).pipe (
         map(response => {
            if ((response as IStringIndex)["_links"] && !(response as IStringIndex)['_links']["next"]) return (response as IStringIndex)["result"];
            else return response;
         }),
         expand((response: ResponseCheckCodeWithBirthday | string, index) => {      
            if (typeof response == 'string' && response == DPSAPI.ERROR) return of(response);
            const el = response['_links' as keyof typeof response];
            if (el) {
               let nextUrl = el['next' as keyof typeof el] as string | undefined;   
               if (!!nextUrl) return  this._dPSOKV1CheckWithCodeBirthdayConsultantuuidGet(nextUrl.split('API/OAS/')[1], headers, payload);
               else if (index == 0) return of((response as IStringIndex)["result"]);
               else return of(response);   
            }
            else return of(response);
         }),
         takeWhile(value => (value as IStringIndex)['_links'] && (value as IStringIndex)['_links']["next"], true),
         reduce((all, current) => { 
            const el = (current as IStringIndex)['_links'];
            if (!!el) {
               if ((all as IStringIndex)['result'] == undefined) (all as IStringIndex)['result' ] = [];
               if (!Array.isArray((all as IStringIndex)['result'])) return Object.assign({}, all, current); 
               else if (!Array.isArray((current as IStringIndex)['result'])) return Object.assign({}, all, current);
               else (all as IStringIndex)['result'].push(...(current as IStringIndex)['result']!)
                  
               return Object.assign([], (all as IStringIndex)["result"]);
            } else return Object.assign({}, all, current);
         }),
         catchError(error => {
            return of('ERROR')
         })   
      )
   }

   private _dPSOKV1CheckWithCodeBirthdayConsultantuuidGet (commandUrl: string, headers: IAuthorizationHeader, payload: object): Observable<string | ResponseCheckCodeWithBirthday> {
      return from<Observable<string>>(dps_api.invoke("open_api", JSON.stringify({verb: 'get', command: commandUrl, headers: headers, json: JSON.stringify(payload)}),15000)).pipe(
         map(response => JSON.parse(response) as ResponseCheckCodeWithBirthday),
         catchError(error => {
            if ((error.indexOf(DPSAPI.ERROR_EXCEPTION_401) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_401_URL) != -1) || (error.indexOf(DPSAPI.ERROR_EXCEPTION_500) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_500_URL) != -1)) {
               throw Error(error);
            }

            const errorOpenApi = this.injector.get(ErrorOpenApiService);
            errorOpenApi.routingCode(error);
            return of(DPSAPI.ERROR);
         })
      )
   }


   /**
   * @param code 
   * @param consultantuuid 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */

   public dPSOKV1CheckWithoutCodeConsultantuuidGet (identifier: object, payload: object, page?: boolean, pagenr?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ResponseCheckCodeWithoutBirthday | string>
   {

      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSOKV1CheckWithoutCodeConsultantuuidGet.');
      }
      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSOKV1CheckWithoutCodeConsultantuuidGet.');
      }

 
      let authMethods: string[] = []; 
      authMethods.push("ClientName");
      authMethods.push("Secret");

      const headers = authMethods.filter(elem => elem == DPSAPI.AUTHEXTERNUSER).length > 0 ? {[DPSAPI.HEADER_AUTH]: DPSAPI.HEADER_AUTH_PREFIX + sessionStorage.getItem(DPSAPI.SESSIONINFO_KEY_ACCESS)} : {};
      let save = Object.values(identifier);

      let commandUrl = '/DPS/OK/v1/check/without/${this.configuration.encodeParam({name: &quot;code&quot;, value: code, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}/${this.configuration.encodeParam({name: &quot;consultantuuid&quot;, value: consultantuuid, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}'; 
      if (commandUrl[0] == '/') {
         commandUrl = commandUrl.substring(1); 
      }
      commandUrl = commandUrl.split('/').map(item => item.includes('${this.configuration.encodeParam') ? save.shift() : item).join('/') 
      commandUrl += `?page=${pagenr ?? '0'}&limit=1000`

      return this._dPSOKV1CheckWithoutCodeConsultantuuidGet(commandUrl, headers, payload).pipe (
         map(response => {
            if ((response as IStringIndex)["_links"] && !(response as IStringIndex)['_links']["next"]) return (response as IStringIndex)["result"];
            else return response;
         }),
         expand((response: ResponseCheckCodeWithoutBirthday | string, index) => {      
            if (typeof response == 'string' && response == DPSAPI.ERROR) return of(response);
            const el = response['_links' as keyof typeof response];
            if (el) {
               let nextUrl = el['next' as keyof typeof el] as string | undefined;   
               if (!!nextUrl) return  this._dPSOKV1CheckWithoutCodeConsultantuuidGet(nextUrl.split('API/OAS/')[1], headers, payload);
               else if (index == 0) return of((response as IStringIndex)["result"]);
               else return of(response);   
            }
            else return of(response);
         }),
         takeWhile(value => (value as IStringIndex)['_links'] && (value as IStringIndex)['_links']["next"], true),
         reduce((all, current) => { 
            const el = (current as IStringIndex)['_links'];
            if (!!el) {
               if ((all as IStringIndex)['result'] == undefined) (all as IStringIndex)['result' ] = [];
               if (!Array.isArray((all as IStringIndex)['result'])) return Object.assign({}, all, current); 
               else if (!Array.isArray((current as IStringIndex)['result'])) return Object.assign({}, all, current);
               else (all as IStringIndex)['result'].push(...(current as IStringIndex)['result']!)
                  
               return Object.assign([], (all as IStringIndex)["result"]);
            } else return Object.assign({}, all, current);
         }),
         catchError(error => {
            return of('ERROR')
         })   
      )
   }

   private _dPSOKV1CheckWithoutCodeConsultantuuidGet (commandUrl: string, headers: IAuthorizationHeader, payload: object): Observable<string | ResponseCheckCodeWithoutBirthday> {
      return from<Observable<string>>(dps_api.invoke("open_api", JSON.stringify({verb: 'get', command: commandUrl, headers: headers, json: JSON.stringify(payload)}),15000)).pipe(
         map(response => JSON.parse(response) as ResponseCheckCodeWithoutBirthday),
         catchError(error => {
            if ((error.indexOf(DPSAPI.ERROR_EXCEPTION_401) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_401_URL) != -1) || (error.indexOf(DPSAPI.ERROR_EXCEPTION_500) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_500_URL) != -1)) {
               throw Error(error);
            }

            const errorOpenApi = this.injector.get(ErrorOpenApiService);
            errorOpenApi.routingCode(error);
            return of(DPSAPI.ERROR);
         })
      )
   }


   /**
   * @param code 
   * @param birthday 
   * @param consultantuuid 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */

   public dPSOKV1LoadBankamountCodeBirthdayConsultantuuidGet (identifier: object, payload: object, page?: boolean, pagenr?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ResponseLoadBankamountData | string>
   {

      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSOKV1LoadBankamountCodeBirthdayConsultantuuidGet.');
      }
      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSOKV1LoadBankamountCodeBirthdayConsultantuuidGet.');
      }
      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSOKV1LoadBankamountCodeBirthdayConsultantuuidGet.');
      }

 
      let authMethods: string[] = []; 
      authMethods.push("ClientName");
      authMethods.push("Secret");

      const headers = authMethods.filter(elem => elem == DPSAPI.AUTHEXTERNUSER).length > 0 ? {[DPSAPI.HEADER_AUTH]: DPSAPI.HEADER_AUTH_PREFIX + sessionStorage.getItem(DPSAPI.SESSIONINFO_KEY_ACCESS)} : {};
      let save = Object.values(identifier);

      let commandUrl = '/DPS/OK/v1/load/bankamount/${this.configuration.encodeParam({name: &quot;code&quot;, value: code, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}/${this.configuration.encodeParam({name: &quot;birthday&quot;, value: birthday, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}/${this.configuration.encodeParam({name: &quot;consultantuuid&quot;, value: consultantuuid, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}'; 
      if (commandUrl[0] == '/') {
         commandUrl = commandUrl.substring(1); 
      }
      commandUrl = commandUrl.split('/').map(item => item.includes('${this.configuration.encodeParam') ? save.shift() : item).join('/') 
      commandUrl += `?page=${pagenr ?? '0'}&limit=1000`

      return this._dPSOKV1LoadBankamountCodeBirthdayConsultantuuidGet(commandUrl, headers, payload).pipe (
         map(response => {
            if ((response as IStringIndex)["_links"] && !(response as IStringIndex)['_links']["next"]) return (response as IStringIndex)["result"];
            else return response;
         }),
         expand((response: ResponseLoadBankamountData | string, index) => {      
            if (typeof response == 'string' && response == DPSAPI.ERROR) return of(response);
            const el = response['_links' as keyof typeof response];
            if (el) {
               let nextUrl = el['next' as keyof typeof el] as string | undefined;   
               if (!!nextUrl) return  this._dPSOKV1LoadBankamountCodeBirthdayConsultantuuidGet(nextUrl.split('API/OAS/')[1], headers, payload);
               else if (index == 0) return of((response as IStringIndex)["result"]);
               else return of(response);   
            }
            else return of(response);
         }),
         takeWhile(value => (value as IStringIndex)['_links'] && (value as IStringIndex)['_links']["next"], true),
         reduce((all, current) => { 
            const el = (current as IStringIndex)['_links'];
            if (!!el) {
               if ((all as IStringIndex)['result'] == undefined) (all as IStringIndex)['result' ] = [];
               if (!Array.isArray((all as IStringIndex)['result'])) return Object.assign({}, all, current); 
               else if (!Array.isArray((current as IStringIndex)['result'])) return Object.assign({}, all, current);
               else (all as IStringIndex)['result'].push(...(current as IStringIndex)['result']!)
                  
               return Object.assign([], (all as IStringIndex)["result"]);
            } else return Object.assign({}, all, current);
         }),
         catchError(error => {
            return of('ERROR')
         })   
      )
   }

   private _dPSOKV1LoadBankamountCodeBirthdayConsultantuuidGet (commandUrl: string, headers: IAuthorizationHeader, payload: object): Observable<string | ResponseLoadBankamountData> {
      return from<Observable<string>>(dps_api.invoke("open_api", JSON.stringify({verb: 'get', command: commandUrl, headers: headers, json: JSON.stringify(payload)}),15000)).pipe(
         map(response => JSON.parse(response) as ResponseLoadBankamountData),
         catchError(error => {
            if ((error.indexOf(DPSAPI.ERROR_EXCEPTION_401) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_401_URL) != -1) || (error.indexOf(DPSAPI.ERROR_EXCEPTION_500) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_500_URL) != -1)) {
               throw Error(error);
            }

            const errorOpenApi = this.injector.get(ErrorOpenApiService);
            errorOpenApi.routingCode(error);
            return of(DPSAPI.ERROR);
         })
      )
   }


   /**
   * @param code 
   * @param birthday 
   * @param consultantuuid 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */

   public dPSOKV1LoadConsentCodeBirthdayConsultantuuidGet (identifier: object, payload: object, page?: boolean, pagenr?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ResponseLoadConsentData | string>
   {

      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSOKV1LoadConsentCodeBirthdayConsultantuuidGet.');
      }
      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSOKV1LoadConsentCodeBirthdayConsultantuuidGet.');
      }
      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSOKV1LoadConsentCodeBirthdayConsultantuuidGet.');
      }

 
      let authMethods: string[] = []; 
      authMethods.push("ClientName");
      authMethods.push("Secret");

      const headers = authMethods.filter(elem => elem == DPSAPI.AUTHEXTERNUSER).length > 0 ? {[DPSAPI.HEADER_AUTH]: DPSAPI.HEADER_AUTH_PREFIX + sessionStorage.getItem(DPSAPI.SESSIONINFO_KEY_ACCESS)} : {};
      let save = Object.values(identifier);

      let commandUrl = '/DPS/OK/v1/load/consent/${this.configuration.encodeParam({name: &quot;code&quot;, value: code, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}/${this.configuration.encodeParam({name: &quot;birthday&quot;, value: birthday, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}/${this.configuration.encodeParam({name: &quot;consultantuuid&quot;, value: consultantuuid, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}'; 
      if (commandUrl[0] == '/') {
         commandUrl = commandUrl.substring(1); 
      }
      commandUrl = commandUrl.split('/').map(item => item.includes('${this.configuration.encodeParam') ? save.shift() : item).join('/') 
      commandUrl += `?page=${pagenr ?? '0'}&limit=1000`

      return this._dPSOKV1LoadConsentCodeBirthdayConsultantuuidGet(commandUrl, headers, payload).pipe (
         map(response => {
            if ((response as IStringIndex)["_links"] && !(response as IStringIndex)['_links']["next"]) return (response as IStringIndex)["result"];
            else return response;
         }),
         expand((response: ResponseLoadConsentData | string, index) => {      
            if (typeof response == 'string' && response == DPSAPI.ERROR) return of(response);
            const el = response['_links' as keyof typeof response];
            if (el) {
               let nextUrl = el['next' as keyof typeof el] as string | undefined;   
               if (!!nextUrl) return  this._dPSOKV1LoadConsentCodeBirthdayConsultantuuidGet(nextUrl.split('API/OAS/')[1], headers, payload);
               else if (index == 0) return of((response as IStringIndex)["result"]);
               else return of(response);   
            }
            else return of(response);
         }),
         takeWhile(value => (value as IStringIndex)['_links'] && (value as IStringIndex)['_links']["next"], true),
         reduce((all, current) => { 
            const el = (current as IStringIndex)['_links'];
            if (!!el) {
               if ((all as IStringIndex)['result'] == undefined) (all as IStringIndex)['result' ] = [];
               if (!Array.isArray((all as IStringIndex)['result'])) return Object.assign({}, all, current); 
               else if (!Array.isArray((current as IStringIndex)['result'])) return Object.assign({}, all, current);
               else (all as IStringIndex)['result'].push(...(current as IStringIndex)['result']!)
                  
               return Object.assign([], (all as IStringIndex)["result"]);
            } else return Object.assign({}, all, current);
         }),
         catchError(error => {
            return of('ERROR')
         })   
      )
   }

   private _dPSOKV1LoadConsentCodeBirthdayConsultantuuidGet (commandUrl: string, headers: IAuthorizationHeader, payload: object): Observable<string | ResponseLoadConsentData> {
      return from<Observable<string>>(dps_api.invoke("open_api", JSON.stringify({verb: 'get', command: commandUrl, headers: headers, json: JSON.stringify(payload)}),15000)).pipe(
         map(response => JSON.parse(response) as ResponseLoadConsentData),
         catchError(error => {
            if ((error.indexOf(DPSAPI.ERROR_EXCEPTION_401) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_401_URL) != -1) || (error.indexOf(DPSAPI.ERROR_EXCEPTION_500) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_500_URL) != -1)) {
               throw Error(error);
            }

            const errorOpenApi = this.injector.get(ErrorOpenApiService);
            errorOpenApi.routingCode(error);
            return of(DPSAPI.ERROR);
         })
      )
   }


   /**
   * @param code 
   * @param birthday 
   * @param consultantuuid 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */

   public dPSOKV1LoadQuestionlistCodeBirthdayConsultantuuidGet (identifier: object, payload: object, page?: boolean, pagenr?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ResponseLoadQuestionList | string>
   {

      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSOKV1LoadQuestionlistCodeBirthdayConsultantuuidGet.');
      }
      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSOKV1LoadQuestionlistCodeBirthdayConsultantuuidGet.');
      }
      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSOKV1LoadQuestionlistCodeBirthdayConsultantuuidGet.');
      }

 
      let authMethods: string[] = []; 
      authMethods.push("ClientName");
      authMethods.push("Secret");

      const headers = authMethods.filter(elem => elem == DPSAPI.AUTHEXTERNUSER).length > 0 ? {[DPSAPI.HEADER_AUTH]: DPSAPI.HEADER_AUTH_PREFIX + sessionStorage.getItem(DPSAPI.SESSIONINFO_KEY_ACCESS)} : {};
      let save = Object.values(identifier);

      let commandUrl = '/DPS/OK/v1/load/questionlist/${this.configuration.encodeParam({name: &quot;code&quot;, value: code, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}/${this.configuration.encodeParam({name: &quot;birthday&quot;, value: birthday, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}/${this.configuration.encodeParam({name: &quot;consultantuuid&quot;, value: consultantuuid, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}'; 
      if (commandUrl[0] == '/') {
         commandUrl = commandUrl.substring(1); 
      }
      commandUrl = commandUrl.split('/').map(item => item.includes('${this.configuration.encodeParam') ? save.shift() : item).join('/') 
      commandUrl += `?page=${pagenr ?? '0'}&limit=1000`

      return this._dPSOKV1LoadQuestionlistCodeBirthdayConsultantuuidGet(commandUrl, headers, payload).pipe (
         map(response => {
            if ((response as IStringIndex)["_links"] && !(response as IStringIndex)['_links']["next"]) return (response as IStringIndex)["result"];
            else return response;
         }),
         expand((response: ResponseLoadQuestionList | string, index) => {      
            if (typeof response == 'string' && response == DPSAPI.ERROR) return of(response);
            const el = response['_links' as keyof typeof response];
            if (el) {
               let nextUrl = el['next' as keyof typeof el] as string | undefined;   
               if (!!nextUrl) return  this._dPSOKV1LoadQuestionlistCodeBirthdayConsultantuuidGet(nextUrl.split('API/OAS/')[1], headers, payload);
               else if (index == 0) return of((response as IStringIndex)["result"]);
               else return of(response);   
            }
            else return of(response);
         }),
         takeWhile(value => (value as IStringIndex)['_links'] && (value as IStringIndex)['_links']["next"], true),
         reduce((all, current) => { 
            const el = (current as IStringIndex)['_links'];
            if (!!el) {
               if ((all as IStringIndex)['result'] == undefined) (all as IStringIndex)['result' ] = [];
               if (!Array.isArray((all as IStringIndex)['result'])) return Object.assign({}, all, current); 
               else if (!Array.isArray((current as IStringIndex)['result'])) return Object.assign({}, all, current);
               else (all as IStringIndex)['result'].push(...(current as IStringIndex)['result']!)
                  
               return Object.assign([], (all as IStringIndex)["result"]);
            } else return Object.assign({}, all, current);
         }),
         catchError(error => {
            return of('ERROR')
         })   
      )
   }

   private _dPSOKV1LoadQuestionlistCodeBirthdayConsultantuuidGet (commandUrl: string, headers: IAuthorizationHeader, payload: object): Observable<string | ResponseLoadQuestionList> {
      return from<Observable<string>>(dps_api.invoke("open_api", JSON.stringify({verb: 'get', command: commandUrl, headers: headers, json: JSON.stringify(payload)}),15000)).pipe(
         map(response => JSON.parse(response) as ResponseLoadQuestionList),
         catchError(error => {
            if ((error.indexOf(DPSAPI.ERROR_EXCEPTION_401) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_401_URL) != -1) || (error.indexOf(DPSAPI.ERROR_EXCEPTION_500) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_500_URL) != -1)) {
               throw Error(error);
            }

            const errorOpenApi = this.injector.get(ErrorOpenApiService);
            errorOpenApi.routingCode(error);
            return of(DPSAPI.ERROR);
         })
      )
   }


   /**
   * @param questionId 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */

   public dPSOKV1LoadQuestionmetadataQuestionIdGet (identifier: object, payload: object, page?: boolean, pagenr?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ResponseLoadQuestionContent | string>
   {

      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSOKV1LoadQuestionmetadataQuestionIdGet.');
      }

 
      let authMethods: string[] = []; 
      authMethods.push("ClientName");
      authMethods.push("Secret");

      const headers = authMethods.filter(elem => elem == DPSAPI.AUTHEXTERNUSER).length > 0 ? {[DPSAPI.HEADER_AUTH]: DPSAPI.HEADER_AUTH_PREFIX + sessionStorage.getItem(DPSAPI.SESSIONINFO_KEY_ACCESS)} : {};
      let save = Object.values(identifier);

      let commandUrl = '/DPS/OK/v1/load/questionmetadata/${this.configuration.encodeParam({name: &quot;questionId&quot;, value: questionId, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}'; 
      if (commandUrl[0] == '/') {
         commandUrl = commandUrl.substring(1); 
      }
      commandUrl = commandUrl.split('/').map(item => item.includes('${this.configuration.encodeParam') ? save.shift() : item).join('/') 
      commandUrl += `?page=${pagenr ?? '0'}&limit=1000`

      return this._dPSOKV1LoadQuestionmetadataQuestionIdGet(commandUrl, headers, payload).pipe (
         map(response => {
            if ((response as IStringIndex)["_links"] && !(response as IStringIndex)['_links']["next"]) return (response as IStringIndex)["result"];
            else return response;
         }),
         expand((response: ResponseLoadQuestionContent | string, index) => {      
            if (typeof response == 'string' && response == DPSAPI.ERROR) return of(response);
            const el = response['_links' as keyof typeof response];
            if (el) {
               let nextUrl = el['next' as keyof typeof el] as string | undefined;   
               if (!!nextUrl) return  this._dPSOKV1LoadQuestionmetadataQuestionIdGet(nextUrl.split('API/OAS/')[1], headers, payload);
               else if (index == 0) return of((response as IStringIndex)["result"]);
               else return of(response);   
            }
            else return of(response);
         }),
         takeWhile(value => (value as IStringIndex)['_links'] && (value as IStringIndex)['_links']["next"], true),
         reduce((all, current) => { 
            const el = (current as IStringIndex)['_links'];
            if (!!el) {
               if ((all as IStringIndex)['result'] == undefined) (all as IStringIndex)['result' ] = [];
               if (!Array.isArray((all as IStringIndex)['result'])) return Object.assign({}, all, current); 
               else if (!Array.isArray((current as IStringIndex)['result'])) return Object.assign({}, all, current);
               else (all as IStringIndex)['result'].push(...(current as IStringIndex)['result']!)
                  
               return Object.assign([], (all as IStringIndex)["result"]);
            } else return Object.assign({}, all, current);
         }),
         catchError(error => {
            return of('ERROR')
         })   
      )
   }

   private _dPSOKV1LoadQuestionmetadataQuestionIdGet (commandUrl: string, headers: IAuthorizationHeader, payload: object): Observable<string | ResponseLoadQuestionContent> {
      return from<Observable<string>>(dps_api.invoke("open_api", JSON.stringify({verb: 'get', command: commandUrl, headers: headers, json: JSON.stringify(payload)}),15000)).pipe(
         map(response => JSON.parse(response) as ResponseLoadQuestionContent),
         catchError(error => {
            if ((error.indexOf(DPSAPI.ERROR_EXCEPTION_401) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_401_URL) != -1) || (error.indexOf(DPSAPI.ERROR_EXCEPTION_500) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_500_URL) != -1)) {
               throw Error(error);
            }

            const errorOpenApi = this.injector.get(ErrorOpenApiService);
            errorOpenApi.routingCode(error);
            return of(DPSAPI.ERROR);
         })
      )
   }


   /**
   * @param code 
   * @param birthday 
   * @param consultantuuid 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */

   public dPSOKV1LoadUserdataCodeBirthdayConsultantuuidGet (identifier: object, payload: object, page?: boolean, pagenr?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ResponseLoadUserData | string>
   {

      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSOKV1LoadUserdataCodeBirthdayConsultantuuidGet.');
      }
      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSOKV1LoadUserdataCodeBirthdayConsultantuuidGet.');
      }
      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSOKV1LoadUserdataCodeBirthdayConsultantuuidGet.');
      }

 
      let authMethods: string[] = []; 
      authMethods.push("ClientName");
      authMethods.push("Secret");

      const headers = authMethods.filter(elem => elem == DPSAPI.AUTHEXTERNUSER).length > 0 ? {[DPSAPI.HEADER_AUTH]: DPSAPI.HEADER_AUTH_PREFIX + sessionStorage.getItem(DPSAPI.SESSIONINFO_KEY_ACCESS)} : {};
      let save = Object.values(identifier);

      let commandUrl = '/DPS/OK/v1/load/userdata/${this.configuration.encodeParam({name: &quot;code&quot;, value: code, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}/${this.configuration.encodeParam({name: &quot;birthday&quot;, value: birthday, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}/${this.configuration.encodeParam({name: &quot;consultantuuid&quot;, value: consultantuuid, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}'; 
      if (commandUrl[0] == '/') {
         commandUrl = commandUrl.substring(1); 
      }
      commandUrl = commandUrl.split('/').map(item => item.includes('${this.configuration.encodeParam') ? save.shift() : item).join('/') 
      commandUrl += `?page=${pagenr ?? '0'}&limit=1000`

      return this._dPSOKV1LoadUserdataCodeBirthdayConsultantuuidGet(commandUrl, headers, payload).pipe (
         map(response => {
            if ((response as IStringIndex)["_links"] && !(response as IStringIndex)['_links']["next"]) return (response as IStringIndex)["result"];
            else return response;
         }),
         expand((response: ResponseLoadUserData | string, index) => {      
            if (typeof response == 'string' && response == DPSAPI.ERROR) return of(response);
            const el = response['_links' as keyof typeof response];
            if (el) {
               let nextUrl = el['next' as keyof typeof el] as string | undefined;   
               if (!!nextUrl) return  this._dPSOKV1LoadUserdataCodeBirthdayConsultantuuidGet(nextUrl.split('API/OAS/')[1], headers, payload);
               else if (index == 0) return of((response as IStringIndex)["result"]);
               else return of(response);   
            }
            else return of(response);
         }),
         takeWhile(value => (value as IStringIndex)['_links'] && (value as IStringIndex)['_links']["next"], true),
         reduce((all, current) => { 
            const el = (current as IStringIndex)['_links'];
            if (!!el) {
               if ((all as IStringIndex)['result'] == undefined) (all as IStringIndex)['result' ] = [];
               if (!Array.isArray((all as IStringIndex)['result'])) return Object.assign({}, all, current); 
               else if (!Array.isArray((current as IStringIndex)['result'])) return Object.assign({}, all, current);
               else (all as IStringIndex)['result'].push(...(current as IStringIndex)['result']!)
                  
               return Object.assign([], (all as IStringIndex)["result"]);
            } else return Object.assign({}, all, current);
         }),
         catchError(error => {
            return of('ERROR')
         })   
      )
   }

   private _dPSOKV1LoadUserdataCodeBirthdayConsultantuuidGet (commandUrl: string, headers: IAuthorizationHeader, payload: object): Observable<string | ResponseLoadUserData> {
      return from<Observable<string>>(dps_api.invoke("open_api", JSON.stringify({verb: 'get', command: commandUrl, headers: headers, json: JSON.stringify(payload)}),15000)).pipe(
         map(response => JSON.parse(response) as ResponseLoadUserData),
         catchError(error => {
            if ((error.indexOf(DPSAPI.ERROR_EXCEPTION_401) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_401_URL) != -1) || (error.indexOf(DPSAPI.ERROR_EXCEPTION_500) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_500_URL) != -1)) {
               throw Error(error);
            }

            const errorOpenApi = this.injector.get(ErrorOpenApiService);
            errorOpenApi.routingCode(error);
            return of(DPSAPI.ERROR);
         })
      )
   }


   /**
   * @param code 
   * @param consultantuuid 
   * @param payloadSendData 
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */

   public dPSOKV1PostDataCodeConsultantuuidPost (identifier: object, payload: object, page?: boolean, pagenr?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ResponseSendData | string>
   {

      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSOKV1PostDataCodeConsultantuuidPost.');
      }
      if (payload === null || payload === undefined) {
         throw new Error('Required parameter payload was null or undefined when calling dPSOKV1PostDataCodeConsultantuuidPost.');
      }

 
      let authMethods: string[] = []; 
      authMethods.push("ClientName");
      authMethods.push("Secret");

      const headers = authMethods.filter(elem => elem == DPSAPI.AUTHEXTERNUSER).length > 0 ? {[DPSAPI.HEADER_AUTH]: DPSAPI.HEADER_AUTH_PREFIX + sessionStorage.getItem(DPSAPI.SESSIONINFO_KEY_ACCESS)} : {};
      let save = Object.values(identifier);

      let commandUrl = '/DPS/OK/v1/post/data/${this.configuration.encodeParam({name: &quot;code&quot;, value: code, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}/${this.configuration.encodeParam({name: &quot;consultantuuid&quot;, value: consultantuuid, in: &quot;path&quot;, style: &quot;simple&quot;, explode: false, dataType: &quot;string&quot;, dataFormat: &quot;string&quot;})}'; 
      if (commandUrl[0] == '/') {
         commandUrl = commandUrl.substring(1); 
      }
      commandUrl = commandUrl.split('/').map(item => item.includes('${this.configuration.encodeParam') ? save.shift() : item).join('/') 
      commandUrl += `?page=${pagenr ?? '0'}&limit=1000`

      return this._dPSOKV1PostDataCodeConsultantuuidPost(commandUrl, headers, payload).pipe (
         map(response => {
            if ((response as IStringIndex)["_links"] && !(response as IStringIndex)['_links']["next"]) return (response as IStringIndex)["result"];
            else return response;
         }),
         expand((response: ResponseSendData | string, index) => {      
            if (typeof response == 'string' && response == DPSAPI.ERROR) return of(response);
            const el = response['_links' as keyof typeof response];
            if (el) {
               let nextUrl = el['next' as keyof typeof el] as string | undefined;   
               if (!!nextUrl) return  this._dPSOKV1PostDataCodeConsultantuuidPost(nextUrl.split('API/OAS/')[1], headers, payload);
               else if (index == 0) return of((response as IStringIndex)["result"]);
               else return of(response);   
            }
            else return of(response);
         }),
         takeWhile(value => (value as IStringIndex)['_links'] && (value as IStringIndex)['_links']["next"], true),
         reduce((all, current) => { 
            const el = (current as IStringIndex)['_links'];
            if (!!el) {
               if ((all as IStringIndex)['result'] == undefined) (all as IStringIndex)['result' ] = [];
               if (!Array.isArray((all as IStringIndex)['result'])) return Object.assign({}, all, current); 
               else if (!Array.isArray((current as IStringIndex)['result'])) return Object.assign({}, all, current);
               else (all as IStringIndex)['result'].push(...(current as IStringIndex)['result']!)
                  
               return Object.assign([], (all as IStringIndex)["result"]);
            } else return Object.assign({}, all, current);
         }),
         catchError(error => {
            return of('ERROR')
         })   
      )
   }

   private _dPSOKV1PostDataCodeConsultantuuidPost (commandUrl: string, headers: IAuthorizationHeader, payload: object): Observable<string | ResponseSendData> {
      return from<Observable<string>>(dps_api.invoke("open_api", JSON.stringify({verb: 'post', command: commandUrl, headers: headers, json: JSON.stringify(payload)}),15000)).pipe(
         map(response => JSON.parse(response) as ResponseSendData),
         catchError(error => {
            if ((error.indexOf(DPSAPI.ERROR_EXCEPTION_401) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_401_URL) != -1) || (error.indexOf(DPSAPI.ERROR_EXCEPTION_500) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_500_URL) != -1)) {
               throw Error(error);
            }

            const errorOpenApi = this.injector.get(ErrorOpenApiService);
            errorOpenApi.routingCode(error);
            return of(DPSAPI.ERROR);
         })
      )
   }


   /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */

   public dPSOKV1VersionGet (identifier: object, payload: object, page?: boolean, pagenr?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ResponseProjectVersion | string>
   {


 
      let authMethods: string[] = []; 
      authMethods.push("ClientName");
      authMethods.push("Secret");

      const headers = authMethods.filter(elem => elem == DPSAPI.AUTHEXTERNUSER).length > 0 ? {[DPSAPI.HEADER_AUTH]: DPSAPI.HEADER_AUTH_PREFIX + sessionStorage.getItem(DPSAPI.SESSIONINFO_KEY_ACCESS)} : {};
      let save = Object.values(identifier);

      let commandUrl = '/DPS/OK/v1/version'; 
      if (commandUrl[0] == '/') {
         commandUrl = commandUrl.substring(1); 
      }
      commandUrl = commandUrl.split('/').map(item => item.includes('${this.configuration.encodeParam') ? save.shift() : item).join('/') 
      commandUrl += `?page=${pagenr ?? '0'}&limit=1000`

      return this._dPSOKV1VersionGet(commandUrl, headers, payload).pipe (
         map(response => {
            if ((response as IStringIndex)["_links"] && !(response as IStringIndex)['_links']["next"]) return (response as IStringIndex)["result"];
            else return response;
         }),
         expand((response: ResponseProjectVersion | string, index) => {      
            if (typeof response == 'string' && response == DPSAPI.ERROR) return of(response);
            const el = response['_links' as keyof typeof response];
            if (el) {
               let nextUrl = el['next' as keyof typeof el] as string | undefined;   
               if (!!nextUrl) return  this._dPSOKV1VersionGet(nextUrl.split('API/OAS/')[1], headers, payload);
               else if (index == 0) return of((response as IStringIndex)["result"]);
               else return of(response);   
            }
            else return of(response);
         }),
         takeWhile(value => (value as IStringIndex)['_links'] && (value as IStringIndex)['_links']["next"], true),
         reduce((all, current) => { 
            const el = (current as IStringIndex)['_links'];
            if (!!el) {
               if ((all as IStringIndex)['result'] == undefined) (all as IStringIndex)['result' ] = [];
               if (!Array.isArray((all as IStringIndex)['result'])) return Object.assign({}, all, current); 
               else if (!Array.isArray((current as IStringIndex)['result'])) return Object.assign({}, all, current);
               else (all as IStringIndex)['result'].push(...(current as IStringIndex)['result']!)
                  
               return Object.assign([], (all as IStringIndex)["result"]);
            } else return Object.assign({}, all, current);
         }),
         catchError(error => {
            return of('ERROR')
         })   
      )
   }

   private _dPSOKV1VersionGet (commandUrl: string, headers: IAuthorizationHeader, payload: object): Observable<string | ResponseProjectVersion> {
      return from<Observable<string>>(dps_api.invoke("open_api", JSON.stringify({verb: 'get', command: commandUrl, headers: headers, json: JSON.stringify(payload)}),15000)).pipe(
         map(response => JSON.parse(response) as ResponseProjectVersion),
         catchError(error => {
            if ((error.indexOf(DPSAPI.ERROR_EXCEPTION_401) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_401_URL) != -1) || (error.indexOf(DPSAPI.ERROR_EXCEPTION_500) != -1 && error.indexOf(DPSAPI.ERROR_EXCEPTION_500_URL) != -1)) {
               throw Error(error);
            }

            const errorOpenApi = this.injector.get(ErrorOpenApiService);
            errorOpenApi.routingCode(error);
            return of(DPSAPI.ERROR);
         })
      )
   }

}

